<template>
  <div class="index" v-loading="loading">
    <div class="index-con">
      <div class="con-info">
        <div class="con-info-title">Conference info</div>
        <div class="con-info-lists">
          <div class="con-info-list-title">
            <span>·</span> 2024 International Journal Forum on Interdisciplinary Food Science (Food Bioscience & Food
            Nutrition)
          </div>
          <div class="con-info-list-title">
            &nbsp;&nbsp;&nbsp;&nbsp;joint with the 16th ISNFF Conference and Exhibition
          </div>
          <div class="con-info-list">
            <span>·</span> <b> Conference Date:</b> <b>December 3-6, 2024</b>
          </div>
          <div class="con-info-list">
            <span>·</span> <b>Venue:</b> <b>Worldhotel Grand Juna Wuxi, Wuxi, China</b>
          </div>
        </div>
      </div>
      <div class="paper-info">
        <div class="con-info-title">Paper info</div>
        <div class="paper-info-con">
          <!-- <div class="paper-info-title">Author Information</div>
          <div class="tip">
            Email address will only be used for communication with the
            authors，Author to contact will receive email from the system
            about this submission, at least one Author to contact should be
            marked.
          </div> -->
          <div v-for="(aaa, index) in peopleList" :key="index">
            <div class="author">
              Author {{ index + 1 }}:
              <span>(Please fill in at least one author information)</span>
            </div>
            <div class="author-lists">
              <div v-for="(item, i) in aaa" class="author-list" :key="i">
                <div v-if="item.radio == 'a'">
                  <p>{{ item.text }}</p>
                  <input type="text" v-model="item.value" />
                </div>
                <div v-if="item.radio == 'b'">
                  <p>{{ item.text }}</p>
                  <el-radio v-model="radio" :label="index">Yes</el-radio>
                </div>
                <div v-if="item.radio == 'd'">
                  <p>{{ item.text }}</p>
                  <el-radio v-model="radios" :label="index">Yes</el-radio>
                </div>
                <div v-if="item.radio == 'c'">
                  <p>{{ item.text }}</p>
                  <el-select v-model="item.value" placeholder="Position">
                    <el-option v-for="itm in item.list" :key="itm.text" :label="itm.text" :value="itm.text">
                    </el-option>
                  </el-select>
                </div>
              </div>
              <div class="author-list" v-if="index != 0" @click="deleteFn(index)">
                <span class="delete-btn bg-red">delete</span>
              </div>
            </div>
          </div>
          <div class="author-btn" @click="addPeopleItem">
            Click here to add more authors
          </div>
          <div class="sub-type">
            <p>Submission Type:*</p>
            <!-- <div class="w-100 my-select">Full Paper(Manuscript)</div> -->
            <el-select class="w-100" v-model="submissionType" placeholder="Full Paper (Persentation and Publication)">
              <el-option label="Abstract (Oral Presentation)" value="3">
              </el-option>
              <el-option label="Abstract (Oral Presentation or Poster)" value="1">
              </el-option>
              <el-option label="Abstract (Poster Only)" value="2"> </el-option>
            </el-select>
          </div>
          <div class="sub-type">
            <p>Topics:*</p>
            <!-- <div class="w-100 my-select">Full Paper(Manuscript)</div> -->
            <el-select class="w-100" v-model="topics" placeholder="Topics">
              <el-option label="Biochemical, biophysical and biological properties of foods (For FIFS 2024 sessions)"
                value="1">
              </el-option>
              <el-option
                label="Genetic, cellular and molecular biology in food production and processing (For FIFS 2024 sessions)"
                value="2">
              </el-option>
              <el-option label="Biomaterials for food-related systems (For FIFS 2024 sessions)" value="3"> </el-option>
              <el-option label="Application of novel technology to foods (For FIFS 2024 sessions)" value="4">
              </el-option>
              <el-option
                label="Exploration of food functional factors and analysis of their mechanisms (For FIFS 2024 sessions)"
                value="5">
              </el-option>
              <el-option label="Food nutrition for specific (special) populations (For FIFS 2024 sessions)" value="6">
              </el-option>
              <el-option label="Interactions between food components and gut microbiota (For FIFS 2024 sessions)"
                value="7"> </el-option>
              <el-option label="Food, immunity and metabolism (For FIFS 2024 sessions)" value="8"> </el-option>
              <el-option
                label="Major Food Bioactives (proteins and peptides, lipids, carbohydrates) (For ISNFF 2024 sessions)"
                value="9">
              </el-option>
              <el-option
                label="Polyphenols, carotenoids, their metabolites and health effects (For ISNFF 2024 sessions)"
                value="10"> </el-option>
              <el-option label="Microbiome, pre- and probiotics and health implications (For ISNFF 2024 sessions)"
                value="11">
              </el-option>
              <el-option label="Controlled release and delivery of functional ingredients (For ISNFF 2024 sessions)"
                value="12">
              </el-option>
              <el-option label="Bioaccessibility and bioavailability of food bioactives (For ISNFF 2024 sessions)"
                value="13">
              </el-option>
              <el-option label="Obesity, diabetes and metabolic syndrome (For ISNFF 2024 sessions)" value="14">
              </el-option>
              <el-option label="Upcycling of food processing discards (For ISNFF 2024 sessions)" value="15">
              </el-option>
              <el-option label="Artificial intelligence and Other topics (For ISNFF 2024 sessions)" value="16">
              </el-option>
            </el-select>
          </div>
          <!--div class="tip">
            Full paper (Manuscript) submission is available now.
          </!--div-->
          <div class="paper-info-title">Title And Abstract</div>
          <div class="sub-type">
            <p>Title:*</p>
            <input type="text" maxlength="200" v-model="title" />
          </div>
          <div class="sub-type">
            <p>Abstract:*</p>
            <textarea
              placeholder="The title and the abstract should be entered as plain text, they should not contain HTML elements."
              v-model="abstract" cols="30" rows="10" maxlength="1000000"></textarea>
          </div>
          <div class="sub-type">
            <p>Keywords:*</p>
            <input maxlength="1000000" v-model="keywords" type="text"
              placeholder="Specify at least three keywords, separated by comma." />
          </div>
          <div class="sub-type">
            <img src="../assets/word.jpg" width="35px">
            <a href="https://www.fifs-isnff-2024.cn/public/uploads/Template.doc" target="_blank">
              <b style="color: #f00;font-size: 20px;">Template File Download</b>
            </a>
          </div>
          <el-upload accept=".doc, .docx" class="upload-demo" :on-success="successReport"
            :action="host + '/VisApi/uploadFile'" :on-exceed="onexceedFn" :before-upload="beforeAvatarUpload" :limit="1"
            :before-remove="removeReport" :file-list="fileList">
            <el-button size="small" type="success">seletct file</el-button>
            <template>
              <b style="color: #f00"> (“.doc” or “.docx” file format only.) </b>
            </template>
          </el-upload>
          <div>
            <!--el-button class="upload-btn" size="small" type="primary">
              <i class="el-icon-top"></i> Upload
            </！el-button-->
          </div>
          <div class="yellow-tip">
            If you have compeleted the form, Please press the 'Submission'
            button below. Uploading may take a while, please do not click the
            button twice. <br>
            After clicking the "Submission" button, if the system does not display "Submitted successfully", please
            contact us at: fifs@jiangnan.edu.cn
          </div>
          <div class="sub-mit" @click="tosubUpThen">Submission</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      fileList: [],
      host: "/api",
      loading: false,
      radios: 0,
      topics: "",
      peopleList: [
        [
          {
            text: "First Name:*",
            value: "",
            radio: "a",
          },
          {
            text: "Middle Name:",
            value: "",
            radio: "a",
          },
          {
            text: "Last Name:*",
            value: "",
            radio: "a",
          },
          {
            text: "Position:",
            value: "",
            radio: "c",
            list: [
              {
                text: "Prof.",
              },
              {
                text: "Associate Prof.",
              },
              {
                text: "Assiatant Prof.",
              },
              {
                text: "Dr.",
              },
              {
                text: "Master",
              },
              {
                text: "Seniot Lecturer",
              },
              {
                text: "Lecturer",
              },
              {
                text: "Ph.D student",
              },
              {
                text: "Master student",
              },
              {
                text: "Undergraduate student",
              },
              {
                text: "Others",
              },
            ],
          },
          {
            text: "Affiliation:*",
            value: "",
            radio: "a",
          },
          {
            text: "Email:*",
            value: "",
            radio: "a",
          },
          {
            text: "Author to contact:",
            value: "1",
            radio: "b",
          },
          {
            text: "Oral/Poster presentation author:",
            value: "1",
            radio: "d",
          },
        ],
      ],
      submissionType: "1",
      title: "",
      abstract: "",
      keywords: "",
      visitor_id: "",
      report_url: "",
      radio: 0,
      id: "",
    };
  },
  mounted() {
    var token = localStorage.getItem("token");
    this.visitor_id = localStorage.getItem("visitor_id");
    if (!token) {
      this.$router.push("/login");
      return;
    }
    this.id = this.$route.query.id;
    if (this.id) {
      this.getDetail();
    }
  },
  methods: {
    getDetail() {
      var params = {
        report_id: this.id,
      };
      var that = this;
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.$http.report_list(params).then((res) => {
        loading.close();
        if (res.code == 200) {
          var con = res.data[0];
          var len = con.file_url.split("/").length;
          that.fileList = [
            { name: con.file_url.split("/")[len - 1], url: con.file_url },
          ];
          that.title = con.title;
          that.submissionType = con.submissionType.toString();
          that.abstract = con.abstract;
          that.keywords = con.keywords;
          that.report_url = con.file_url;
          var datas = con.report_people;
          var num = [];
          // radio
          for (var i = 0; i < datas.length; i++) {
            if (datas[i].Corresponding_author == 1) {
              that.radio = i;
            }
            if (datas[i].Oral_presentation_author == 1) {
              that.radios = i;
            }
            num.push([
              {
                text: "First Name:*",
                value: datas[i].Firstname,
                radio: "a",
              },
              {
                text: "Middle Name:",
                value: datas[i].Middlename,
                radio: "a",
              },
              {
                text: "Last Name:*",
                value: datas[i].Lastname,
                radio: "a",
              },
              {
                text: "Position:",
                value: datas[i].Position,
                radio: "c",
                list: [
                  {
                    text: "Prof.",
                  },
                  {
                    text: "Associate Prof.",
                  },
                  {
                    text: "Assiatant Prof.",
                  },
                  {
                    text: "Dr.",
                  },
                  {
                    text: "Master",
                  },
                  {
                    text: "Seniot Lecturer",
                  },
                  {
                    text: "Lecturer",
                  },
                  {
                    text: "Ph.D student",
                  },
                  {
                    text: "Master student",
                  },
                  {
                    text: "Undergraduate student",
                  },
                  {
                    text: "Others",
                  },
                ],
              },
              {
                text: "Affiliation:*",
                value: datas[i].Affiliation,
                radio: "a",
              },
              {
                text: "Email:*",
                value: datas[i].email,
                radio: "a",
              },
              {
                text: "Author to contact:",
                value: datas[i].Corresponding_author,
                radio: "b",
              },
              {
                text: "Oral/Poster presentation author:",
                value: datas[i].Oral_presentation_author,
                radio: "d",
              },
            ]);
          }
          that.peopleList = num;
        } else {
          that.$message.error(res.msg);
        }
      });
    },
    onexceedFn(a, b) { },
    successReport(a) {
      this.report_url = a.data;
      console.log(a.data, "-=-=-=-=");
      this.loading = false;
    },
    removeReport(a) {
      if (a.response && a.response.data) {
        for (var i = 0; i < this.report_url.length; i++) {
          if (this.report_url[i] == a.response.data) {
            this.report_url.splice(i, 1);
          }
        }
      }
      console.log(this.report_url);
    },
    beforeAvatarUpload(rawFile) {
      console.log(rawFile);
      if (rawFile.size > 1024 * 1024 * 200) {
        this.$message({
          message: "文件不能超过200M",
          type: "error",
        });
        return false;
      } else {
        this.loading = true;
        return true;
      }
    },
    addPeopleItem() {
      var item = [
        {
          text: "First Name:*",
          value: "",
          radio: "a",
        },
        {
          text: "Middle Name:",
          value: "",
          radio: "a",
        },
        {
          text: "Last Name:*",
          value: "",
          radio: "a",
        },
        {
          text: "Position:*",
          value: "",
          radio: "c",
          list: [
            {
              text: "Position",
            },
            {
              text: "Prof.",
            },
            {
              text: "Associate Prof.",
            },
            {
              text: "Assiatant Prof.",
            },
            {
              text: "Dr.",
            },
            {
              text: "Master",
            },
            {
              text: "Seniot Lecturer",
            },
            {
              text: "Lecturer",
            },
            {
              text: "Ph.D student",
            },
            {
              text: "Master student",
            },
            {
              text: "Undergraduate student",
            },
            {
              text: "Others",
            },
          ],
        },
        {
          text: "Affiliation:*",
          value: "",
          radio: "a",
        },
        {
          text: "Email:*",
          value: "",
          radio: "a",
        },
        {
          text: "Author to contact:",
          value: "1",
          radio: "b",
        },
        {
          text: "Oral/Poster presentation author:",
          value: "1",
          radio: "d",
        },
      ];
      this.peopleList.push(item);
    },
    deleteFn(index) {
      console.log(this.peopleList, "-----");
      if (this.radio == index) {
        this.radio = 0;
      }
      if (this.radios == index) {
        this.radios = 0;
      }
      this.peopleList.splice(index, 1);
    },
    tosubUpThen() {
      if (!this.title) {
        this.$message.error("Please enter a title");
        return;
      }
      if (!this.abstract) {
        this.$message.error("Please enter Abstract");
        return;
      }
      if (!this.keywords) {
        this.$message.error("Please enter keyword");
        return;
      }

      if (this.peopleList.length == 0) {
        this.$message.error("Please enter author");
        return;
      }
      var peopleList = this.peopleList;
      var con = [];
      for (var i = 0; i < peopleList.length; i++) {
        if (!peopleList[i][0].value) {
          this.$message.error(
            "Please enter Author" + Number(i + 1) + "'s Firstname"
          );
          return;
        }
        if (!peopleList[i][2].value) {
          this.$message.error(
            "Please enter Author" + Number(i + 1) + "'s Lastname"
          );
          return;
        }
        if (!peopleList[i][3].value) {
          this.$message.error(
            "Please enter Author" + Number(i + 1) + "'s Position"
          );
          return;
        }
        if (!peopleList[i][4].value) {
          this.$message.error(
            "Please enter Author" + Number(i + 1) + "'s Affiliation"
          );
          return;
        }
        if (!peopleList[i][5].value) {
          this.$message.error(
            "Please enter Author" + Number(i + 1) + "'s email"
          );
          return;
        }
        let item = {
          Firstname: peopleList[i][0].value,
          Middlename: peopleList[i][1].value,
          Lastname: peopleList[i][2].value,
          Position: peopleList[i][3].value,
          Affiliation: peopleList[i][4].value,
          email: peopleList[i][5].value,
          Corresponding_author: 0,
          Oral_presentation_author: 0,
        };
        con.push(item);
      }
      con[Number(this.radio)].Corresponding_author = 1;
      con[Number(this.radios)].Oral_presentation_author = 1;
      var params = {
        report_people: JSON.stringify(con),
        submissionType: this.submissionType,
        title: this.title,
        abstract: this.abstract,
        keywords: this.keywords,
        file_url: this.report_url,
        visitor_id: this.visitor_id,
      };
      var that = this;
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      if (this.id) {
        // 修改
        params.report_id = this.id;
        this.$http.upload_report(params).then((res) => {
          loading.close();
          if (res.code == 200) {
            that.$message.success("Submitted Successfully ！");
            setTimeout(() => {
              that.$router.push("/loginThenzh");
            }, 200);
          } else {
            that.$message.error(res.msg);
          }
        });
      } else {
        // 添加
        this.$http.add_report(params).then((res) => {
          loading.close();
          if (res.code == 200) {
            that.$message.success("Submitted Successfully ！");
            setTimeout(() => {
              that.$router.push("/loginThenzh");
            }, 200);
          } else {
            that.$message.error(res.msg);
          }
        });
      }
    },
  },
};
</script>

<style scoped>
.index-con {
  margin: 0 auto;
  width: 1200px;
  padding: 20px;
  box-sizing: border-box;
}

.con-info,
.paper-info {
  border: 1px solid #ddd;
  border-radius: 4px;
  margin-bottom: 20px;
}

.con-info-title {
  border-bottom: 1px solid #ddd;
  background: #f5f5f5;
  padding: 15px;
  font-size: 18px;
  font-weight: 600;
  box-sizing: border-box;
}

.con-info-lists {
  padding: 20px;
  box-sizing: border-box;
}

.con-info-lists span {
  font-size: 24px;
  font-weight: 500;
}

.con-info-list-title {
  font-weight: 800;
  font-size: 18px;
}

.paper-info-con {
  padding: 20px;
  box-sizing: border-box;
}

.paper-info-title {
  font-size: 16px;
  font-weight: 600;
  padding: 15px 0;
  box-sizing: border-box;
}

.tip {
  padding: 15px;
  margin-bottom: 20px;
  border: 1px solid transparent;
  border-radius: 4px;
  color: #31708f;
  background-color: #d9edf7;
  border-color: #bce8f1;
}

.author {
  color: #31708f;
  font-weight: 600;
  margin-bottom: 15px;
}

.author span {
  color: #f00;
}

.author-lists {
  display: flex;
  flex-wrap: wrap;
}

.delete-btn {
  padding: 8px 25px;
  border-radius: 4px;
  color: #fff;
  cursor: pointer;
  display: inline-block;
  box-sizing: border-box;
  background: #f00;
}

.author-list {
  width: calc(25% - 20px);
  margin-right: 20px;
  margin-bottom: 20px;
}

.author-list:nth-of-type(4n) {
  margin-right: 0;
}

.author-list p {
  font-weight: 600;
  margin-bottom: 4px;
}

.author-list input,
.sub-type input {
  width: 100%;
  height: 35px;
  border: 1px solid #ccc;
  border-radius: 4px;
  padding-left: 15px;
  box-sizing: border-box;
}

.my-select {
  border-radius: 4px;
  width: 100%;
  height: 35px;
  line-height: 35px;
  padding-left: 15px;
  box-sizing: border-box;
  border: 1px solid #ccc;
}

.author-btn {
  display: inline-block;
  padding: 8px 20px;
  font-size: 12px;
  line-height: 1.5;
  border-radius: 3px;
  cursor: pointer;
  margin-bottom: 20px;
  color: #fff;
  background-color: #5bc0de;
  border-color: #46b8da;
}

.sub-type {
  margin-bottom: 20px;
}

.sub-type p {
  margin-bottom: 5px;
  font-weight: 600;
}

.sub-type textarea {
  width: 100%;
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 20px;
  box-sizing: border-box;
}

.upload-btn {
  margin-top: 20px;
  margin-bottom: 20px;
}

.yellow-tip {
  padding: 15px;
  margin-bottom: 20px;
  border: 1px solid transparent;
  border-radius: 4px;
  color: #8a6d3b;
  margin-top: 20px;
  background-color: #fcf8e3;
  border-color: #faebcc;
}

.sub-mit {
  width: auto;
  display: inline-block;
  padding: 10px 46px;
  cursor: pointer;
  font-size: 18px;
  line-height: 1.33;
  border-radius: 6px;
  color: #fff;
  background-color: #428bca;
  border-color: #357ebd;
}

.w-100 {
  width: 100%;
}

@media screen and (max-width: 768px) {
  .index-con {
    width: 100%;
  }

  .author-lists {
    display: block;
  }

  .author-list {
    width: 100%;
    margin: 20px 0;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/submissionUploadzh.vue